import React, { useState } from 'react';
import useRequestStreets from '../../../../../../queries/useRequestStreets';
import useRequestHouses from '../../../../../../queries/useRequestHouses';
import useRequestAddresses from '../../../../../../queries/useRequestAddresses';
import Address from '../../ui/Address/Address';
import {
  getDocOptionsSelect,
  getDocOptionsSelectStreet,
} from '../../../../utils/getDocOptionsSelect';
import useRequestStreetsByServiceCompany from '../../../../../../queries/useRequestStreetsByServiceCompany';
import ExpandedCard from '../../../../components/ExpandedCard/ExpandedCard';
import { useSelector } from 'react-redux';
import { ReactComponent as AddressFilterIcon } from '../../../../../../resource/AddressFilterIcon.svg';

const AddressCard = () => {
  const [expanded, setExpanded] = useState(true);

  const handleExpanded = () => setExpanded((prev) => !prev);

  const { typeId, streetId, houseId, companyId } = useSelector(
    (state) => state.documentFilterNewStore
  );

  const hasCompany = Boolean(companyId);

  const { data: streetsByCompany = [], isFetching: isStreetByCompanyFetching } =
    useRequestStreetsByServiceCompany(
      { serviceCompanyIds: [companyId] },
      { staleTime: Infinity, enabled: hasCompany }
    );

  const { data: streets = [], isFetching: isStreetFetching } =
    useRequestStreets({ staleTime: Infinity, enabled: !hasCompany });

  const { data: houses = [], isFetching: isHouseFetching } = useRequestHouses(
    streetId,
    {
      enabled: Boolean(streetId),
    }
  );

  const { data: flats = [], isFetching: isFlatFetching } = useRequestAddresses(
    houseId,
    {
      enabled: Boolean(houseId && streetId),
    }
  );

  const streetOptions = hasCompany ? streetsByCompany : streets;
  const isStreetFetchingAll = isStreetByCompanyFetching || isStreetFetching;

  // useEffect(() => {
  //   if (typeId) {
  //     setExpanded(true);
  //     return;
  //   }

  //   setExpanded(false);
  // }, [typeId]);

  return (
    // <Tooltip title={!typeId && 'Укажите тип документа, чтобы открыть фильтры'}>
    //   <div>
    <ExpandedCard
      expanded={expanded}
      handleExpanded={handleExpanded}
      heading="Адрес"
      // disabled={!typeId}
      icon={<AddressFilterIcon />}
    >
      <Address
        optionStreet={getDocOptionsSelectStreet(streetOptions)}
        optionHouse={getDocOptionsSelect(houses)}
        optionsFlat={getDocOptionsSelect(flats)}
        isStreetFetching={isStreetFetchingAll}
        isHouseFetching={isHouseFetching}
        isFlatFetching={isFlatFetching}
      />
    </ExpandedCard>
    //   </div>
    // </Tooltip>
  );
};

export default AddressCard;
